import React, { useEffect, useState } from "react";
import CardWithImage from "../../components/Cards/CardWithImage";
import { FaDownload } from "react-icons/fa";
import axiosInstance from "../../services/api/axiosInstance";
import { BsFillArrowUpCircleFill } from "react-icons/bs";
import images from "../../utils/images";

const LearningPage = () => {
  const learningCards = ["dummy", "dummy", "dummy", "dummy", "dummy", "dummy"];

  const [learningData, setLearningData] = useState([]);
  const [learningLoading, setlearningLoading] = useState(false);
  const [modalApiContent, setModalApiContent] = useState([]);




  const [modalLoading, setModalLoading] = useState(false)

  useEffect(() => {
    setModalApiContent([]);
    setlearningLoading(false);

    // Get Learning Content
    const getlearningDatas = async () => {
      try {
        const response = await axiosInstance.get("/professional_learning")
        if (response.data.error_code === 0) {
          setlearningLoading(true)
          setLearningData(response.data.data);
          getModalData(response.data.data[0].id);
        }
      } catch (err) {
        console.log(err);
      }
    };
    (async () => getlearningDatas())();
  }, []);



  // scroll to top 

  const [isVisible, setIsVisible] = useState(false);



  // Function to handle scroll event
  const handleScroll = () => {

    if (window.scrollY > 200) { // Adjust this value according to your needs
      setIsVisible(true);
    } else {
      setIsVisible(false);

    }
  };

  // Function to scroll to the top of the page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional: smooth scrolling animation
    });
  };

  // Add scroll event listener
  window.onscroll = function () {
    handleScroll();
  };






  // Post Modal Content
  const getModalData = async (modalId) => {
    let learningParams = {
      id: modalId,
    };
    try {
      setModalLoading(true)
      const response = await axiosInstance.post("/get_detailed_description_learning", learningParams)
      setModalLoading(false)
      if (response.data.error_code === 0) {
        setModalApiContent(response.data.data[0].detailed_description);
      }

    } catch (err) {
      console.log(err);
    }
  };




  return (
    <>
      <div className={learningData.length > 6 ? " learning-page-bg overflow-scroll" : "learning-page-bg overflow-scroll learning-page-height"}>
        <div className="container pt-sm-5 px-sm-5 bottom-navigation-margin">
          {learningLoading ? (
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 g-4 mt-0 mb-4">

              {
                learningData.length > 0 ?
                  learningData.map((value, index) => {
                    return (
                      <div className="col" key={index}>
                        <CardWithImage
                          cardImage={value.image}
                          cardTitle={value.title}
                          companyName={value.company_name}
                          companyImage={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${value.profile_image}`}
                          postedDate={value.posted_on}
                          id={value.id}
                          cardTitleStyle="learningTitle"
                          imageClassName="rounded-3 img-fluid learning-img-height w-100"
                          cardText={value.detailed_description}
                          cardKey={index}
                          cardParaTestId="professionalTestId"
                          cardButtonTestId="cardButton"
                          role="learning"
                          firstButton_Name="Download"
                          secondButton_Name="Learn&nbsp;more"
                          icon={<FaDownload className="me-2" />}
                          firstCardColor="outline-secondary"
                          secondCardColor="brand-color"
                          modalContent={modalApiContent}
                          leftLearnUrl={value.attached_file}
                          rightLearnUrl={value.url}
                          getModalData={getModalData}
                          modalId={value.id}
                          modalLoading={modalLoading}
                        />
                        {/* scroll to top */}
                        <div
                          className="professional-home-scroll-to-top-icon"
                          id="scroll-to-top-icon"
                          onClick={scrollToTop}
                          title="Scroll to top"
                          style={{ display: isVisible ? 'block' : 'none' }} // Show/hide button based on visibility state
                        >
                          <BsFillArrowUpCircleFill className='fs-1 brand-color' />
                        </div>
                      </div>
                    );
                  })
                  :
                  <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                    <div className='d-flex  justify-content-center h-100'>
                      <img src={images.noRecordsFound} width={250} height={250} alt="no records image"/>
                    </div>
                  </div>
              }
            </div>
          ) : (
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 mt-0 mb-4">
              {
                learningCards.map((v, i) => {
                  return (
                    <div className="col" key={i}>
                      <div
                        className="card border-0 p-0 rounded-3 overflow-hidden placeholder-glow"
                        aria-hidden="true"
                        key={i}
                      >
                        <div className="col-12 p-3">
                          <span className="placeholder col-12 py-4 rounded-top"></span>
                          <span className="placeholder col-12 py-4"></span>
                          <span className="placeholder col-12 py-4"></span>
                          <span className="placeholder col-12 py-4 rounded-bottom"></span>
                        </div>

                        <div className="ps-4">
                          <span className="placeholder col-2 py-4 rounded-5 "></span>
                          <span className="placeholder col-3 ms-2 py-3 rounded-3"></span>
                        </div>
                        <div className="card-body p-0">
                          <div className="p-3 py-4">
                            <h5 className="card-title ">
                              <span className="placeholder col-6 py-3 rounded-3"></span>
                            </h5>
                            <span className="placeholder col-3 py-2 rounded"></span>
                            <p className="card-text">
                              <span className="placeholder col-12 py-2 rounded "></span>
                              <span className="placeholder col-12 py-2 rounded"></span>
                              <span className="placeholder col-12 py-2 rounded"></span>
                              <span className="placeholder col-8 py-2 rounded"></span>
                            </p>
                          </div>
                          <div className="card-footer d-flex justify-content-between">
                            <button className="btn btn-outline-secondary placeholder col-5"></button>
                            <button className="btn btn-outline-secondary placeholder col-5"></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              }




            </div>
          )}

        </div>

        <section className={learningData.length > 3 ? "professional-home-footer " : "professional-home-footer fixed-bottom"}>
          <div className="container">
            <div className="col-12 py-3 row">
              <div className="col-6">
                <h6 className="mb-0">© 2024 2nd Careers. All rights reserved.</h6>
              </div>
              <div className="col-6">
                <h6 className="text-end mb-0"><span className="cursorPointer"  onClick={()=> window.open("https://www.2ndcareers.com/terms-conditions","_blank")}>Terms&nbsp;and&nbsp;conditions
                </span> | <span className="cursorPointer" onClick={()=> window.open("https://www.2ndcareers.com/privacypolicy","_blank")}>Privacy policy</span></h6>
              </div>
            </div>
          </div>
        </section>

      </div>
    </>
  );
};

export default LearningPage;